/* eslint-disable no-unsafe-optional-chaining */
import { ProgressBar } from '@components';
import { useScreenSize } from '@hooks';
import { Flex } from '@styles';
import { func, object } from 'prop-types';
import React, { useState } from 'react';
import {
  FinishedCard,
  ScenarioCard,
} from 'src/screens/ScenarioPage/components';

const ScenarioLayout = ({ onFinish, scenario }) => {
  const { isTabletSM } = useScreenSize();

  const [currentStep, setCurrentStep] = useState(0);
  const [validatedAnswers, setValidatedAnswers] = useState(null);

  const handleNextButtonClick = () => {
    if (currentStep === scenario?.steps?.length) return;

    setCurrentStep(currentStep + 1);
  };

  const handleFinishButtonPress = () => {
    onFinish();
  };

  const handleTryAgainButtonClick = () => {
    setCurrentStep(0);
  };

  const isTestFinished = currentStep === scenario?.steps?.length;

  return (
    <Flex flexDirection="column">
      <ProgressBar
        currentStep={currentStep}
        items={isTestFinished ? validatedAnswers : scenario?.steps}
        withCorrection={isTestFinished}
      />
      {isTestFinished ? (
        <FinishedCard
          correctAnswersCount={
            validatedAnswers.filter((answer) => answer.is_correct).length
          }
          onFinishButtonPress={handleFinishButtonPress}
          onTryAgainButtonPress={handleTryAgainButtonClick}
          questionsCount={scenario?.steps?.length}
          titleStyleProps={{
            variant: isTabletSM ? 'BN-bold-s56-lh67' : 'BN-bold-s88-lh75',
          }}
          withBorder
        />
      ) : (
        <ScenarioCard
          cardContent={scenario?.steps?.[currentStep]}
          mb={80}
          mt={24}
          onNextButtonClick={handleNextButtonClick}
          progress={`${currentStep + 1}/${scenario?.steps?.length}`}
          setValidatedAnswers={setValidatedAnswers}
        />
      )}
    </Flex>
  );
};

ScenarioLayout.propTypes = {
  onFinish: func.isRequired,
  scenario: object.isRequired,
};

export default ScenarioLayout;
